import { Paragraph, Separator, usePageWidth, MarginBox } from '@fs/zion-ui'
import type { CategoryType } from '@fs/zion-tree-types'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { getCategoryTitleMap } from '../getCategoryTitleMap'
import NoItemsMessageSkeleton from './NoItemsMessageSkeleton'

type Props = {
  category: CategoryType
}

// Mirrors a single loading `Category`: the real (count-less) section title followed by a
// "no items" skeleton. On desktop the real header is an `ExpanderHeader`; on smaller screens
// it is a plain `Paragraph`. This replicates both without the interactive Expander.
export default function CategorySkeleton({ category }: Props): JSX.Element {
  const [t] = useTranslation()
  const isDesktop = usePageWidth()({ md: true })
  const title = getCategoryTitleMap(t)[category]

  if (isDesktop) {
    return (
      <>
        <MarginBox marginY="xs">
          <h2>
            <MarginBox marginY="nano">{title}</MarginBox>
          </h2>
        </MarginBox>
        <NoItemsMessageSkeleton />
      </>
    )
  }

  return (
    <>
      <Paragraph size="sm">{title}</Paragraph>
      <Separator size="nano" />
      <NoItemsMessageSkeleton />
    </>
  )
}
